import { filter, has } from "ramda";
import { TemplateReaderContext } from "./types";
import { toId } from "../templates/utils";
import { isUndefined } from "ramda-adjunct";
import { ProtectedInfo } from "../_types";

export const readProtected = (src:ProtectedInfo): ProtectedInfo => {
  const result = {
    protected: src?.protected ?? true,
    roles: src?.roles || []
  };
  return result;
}

export const hasTemplate = has("template");

export const hasId = has("id");

export const getId = (segments: string[]) => toId(segments);

export const setId = (context: TemplateReaderContext<any>) => {
  context.result.id = getId(filter((x) => !isUndefined(x),[context.source.id, context?.section?.id]));
  return context;
}

export const exceptUndefined = filter((x) => !isUndefined(x));

export const joinExceptUndefined = (separator: string) => (segments: string[]) => exceptUndefined(segments).join(separator);

export const setProtected = (context: TemplateReaderContext<any>) => {
  context.result.route = {...context.result.route,...readProtected(context.source)};
  return context;
}

export const setLayout = (context: TemplateReaderContext<any>) => {
  context.result.components!.layout = context.source.layout;
  return context;
}

export const readPath  = (segments: string[]) => joinExceptUndefined("/")(segments);

export const setRoute = (context: TemplateReaderContext<any>) => {
  context.result.route = {
    ...context.result.route,
    ...readProtected(context.source),
    id: "r_" + context.result.id!,
    to: readPath([context?.section?.path || context?.section?.id, context.source.path])
  };
  return context;
}

export const setComponent = (context: TemplateReaderContext<any>) => {
  if(context.source?.Container) {
    const componentProps = [{
      Component: context.source.Component,
      cat: "Component",
      type: "Component",
    }
    ];
    context.result.view.Component = context.source?.Container;
    context.result.view.children = [...context.result.view.children || [], ...componentProps];
  }
  else {
    context.result.view.children = [
      ...context.source?.children || [],
      { Component: context.source?.Component, cat: "Component", type: "Component" }];
  }
  return context;
}
